import { useContext } from "react";
import DecksContext from "../context/DecksContext";

/**
 * Custom hook to access deck data from DecksContext
 * @returns {{ decks: Array, loading: boolean, error: string|null, refreshDecks: Function }}
 */
const useDecks = () => {
  const context = useContext(DecksContext);

  if (context === null) {
    throw new Error("useDecks must be used within a DecksProvider");
  }

  return context;
};

export default useDecks;
